import React from "react";

import {
	UncheckedRadioIcon,
	UncheckedCheckboxIcon,
} from "../../../../../resource/icons";

const AnswerCheckBox = ({ questionId, form: { getFieldValue } }) => {
	const answerType = getFieldValue(`questions[${questionId}].answerType`);
	return (
		<div>
			{answerType === "one" ? (
				<UncheckedRadioIcon className="control" tabIndex="-1" />
			) : (
				<UncheckedCheckboxIcon className="control" tabIndex="-1" />
			)}
		</div>
	);
};

export default AnswerCheckBox;
